export default __webpack_public_path__ + "static/media/fw-madelyn-er-Rose Gold.fc046195.mp4";